import seoReducerMap from 'wanderu-ducks-seo';

import CarrierGuide from '../containers/CarrierGuide/CarrierGuide';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default CarrierGuide;
